export const brandColors = {
  mark: "#326EA5",
  accent: "#FA9B2D",
  current: "currentColor",
};

export const brandAssets = {
  logomark: {
    viewBox: "0 0 32 32",
    path: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
    paths: [
      {
        d: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
        role: "mark",
        strokeWidth: 2.5,
        strokeLinecap: "round",
      },
      {
        d: "M10 18v5.5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5V18M10 18c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5M10 14c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5",
        role: "mark",
        strokeWidth: 2,
        strokeLinecap: "round",
      },
      {
        d: "m23 5 4 4-4 4M27 9h-7",
        role: "accent",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
    ],
    labels: [],
  },
  logomarkSmall: {
    viewBox: "0 0 24 24",
    path: "M5 14.5a5 5 0 0 1 1.2-9.84A6.5 6.5 0 0 1 18.5 7a4.5 4.5 0 0 1 .5 8.94",
    paths: [
      {
        d: "M5 14.5a5 5 0 0 1 1.2-9.84A6.5 6.5 0 0 1 18.5 7a4.5 4.5 0 0 1 .5 8.94",
        role: "mark",
        strokeWidth: 2,
        strokeLinecap: "round",
      },
      {
        d: "M7 13v4c0 1.1 2.24 2 5 2s5-.9 5-2v-4M7 13c0 1.1 2.24 2 5 2s5-0.9 5-2",
        role: "mark",
        strokeWidth: 1.7,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      {
        d: "M18 3l3 3-3 3M21 6h-5",
        role: "accent",
        strokeWidth: 1.7,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
    ],
    labels: [],
  },
  horizontal: {
    viewBox: "0 0 168 32",
    path: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
    paths: [
      {
        d: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
        role: "mark",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        transform: "translate(0 0) scale(1)",
      },
      {
        d: "M10 18v5.5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5V18M10 18c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5",
        role: "mark",
        strokeWidth: 2,
        transform: "translate(0 0) scale(1)",
      },
      {
        d: "m23 5 4 4-4 4M27 9h-7",
        role: "accent",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        transform: "translate(0 0) scale(1)",
      },
    ],
    labels: [
      {
        text: "Pikbase",
        role: "current",
        x: 40,
        y: 23,
        fontSize: 25,
        fontWeight: 600,
      },
    ],
  },
  stacked: {
    viewBox: "0 0 128 80",
    path: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
    paths: [
      {
        d: "M7 20.5a6.5 6.5 0 0 1 1.7-12.78A8.5 8.5 0 0 1 24.5 11a5.5 5.5 0 0 1 .5 10.96",
        role: "mark",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        transform: "translate(48 0) scale(1)",
      },
      {
        d: "M10 18v5.5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5V18M10 18c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5",
        role: "mark",
        strokeWidth: 2,
        transform: "translate(48 0) scale(1)",
      },
    ],
    labels: [
      {
        text: "Pikbase",
        role: "current",
        x: 64,
        y: 58,
        fontSize: 24,
        fontWeight: 600,
        textAnchor: "middle",
      },
    ],
  },
  wordmark: {
    viewBox: "0 0 128 32",
    paths: [],
    labels: [
      {
        text: "Pikbase",
        role: "current",
        x: 0,
        y: 24,
        fontSize: 25,
        fontWeight: 600,
      },
    ],
  },
};

export default brandAssets;
